import { render, staticRenderFns } from "./Network.vue?vue&type=template&id=804e934a"
import script from "./Network.vue?vue&type=script&lang=js"
export * from "./Network.vue?vue&type=script&lang=js"
import style0 from "./Network.vue?vue&type=style&index=0&id=804e934a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports